module.exports = (__webpack_require__(24))(14);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/immutable/dist/immutable.js from dll-reference lib_core
// module id = 132
// module chunks = 105